import { render, staticRenderFns } from "./GetMovieActors.vue?vue&type=template&id=0eb41a22&scoped=true&"
import script from "./GetMovieActors.vue?vue&type=script&lang=js&"
export * from "./GetMovieActors.vue?vue&type=script&lang=js&"
import style0 from "./GetMovieActors.vue?vue&type=style&index=0&id=0eb41a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb41a22",
  null
  
)

export default component.exports